import { Fraga } from "@/types/riskbedomning";

// Lazy loading utilities for questions data
export const loadFragorByPhase = async (phase: string): Promise<Fraga[]> => {
  try {
    switch (phase) {
      case 'byggskede':
        const byggskedeModule = await import('./byggskede');
        return byggskedeModule.byggskedeFragor;
      
      case 'bruksskede':
        const bruksskedeModule = await import('./bruksskede');
        return bruksskedeModule.bruksskedeFragor;
      
      default:
        console.warn(`Unknown phase: ${phase}`);
        return [];
    }
  } catch (error) {
    console.error(`Failed to load questions for phase ${phase}:`, error);
    return [];
  }
};

// Load all questions progressively
export const loadAllFragor = async (): Promise<Fraga[]> => {
  try {
    const [byggskede, bruksskede] = await Promise.all([
      loadFragorByPhase('byggskede'),
      loadFragorByPhase('bruksskede')
    ]);
    
    return [...byggskede, ...bruksskede];
  } catch (error) {
    console.error('Failed to load all questions:', error);
    return [];
  }
};

// Check if phase data is available in cache
export const isPhaseDataCached = (phase: string): boolean => {
  // This would check if the phase module is already loaded
  // For now, we'll assume it's not cached initially
  return false;
};

// Preload a phase in the background
export const preloadPhase = async (phase: string): Promise<void> => {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(async () => {
      await loadFragorByPhase(phase);
    });
  } else {
    setTimeout(async () => {
      await loadFragorByPhase(phase);
    }, 100);
  }
};